function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { c as classnames } from './index2.js';
/**
 * returns the correct format to use the color in the style
 * @param color{string}
 * @return {string}
 */

var getColor = function getColor(color) {
  return color.includes('--color') || color.includes('--skp') ? "var(".concat(color, ")") : color;
};
/**
 * returns random value that can be used e.g. do disable autocompletion for some inputs because default "off" property doest always work correctly
 * @return {string}
 */


var getRandomString = function getRandomString() {
  return String(Math.ceil(Date.now() * Math.random()));
};

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
/**
 * returns modificated **classNames** instance, takes prefix as first & required argument and **skpClass** as second & optional (**adds dash after prefix, turns one space string into prefix (' '), does not add prefix to skpClass**)
 * @return {function(): string}
 */

var clsnms = function clsnms(prefix, skpClass) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (classnames(args).split(' ').map(function (className) {
      return className === '' ? prefix : prefix + '-' + className;
    }).join(' ') + ' ' + (skpClass ? skpClass : '')).trim();
  };
};
/**
 * returns instance of above-declared clsnms with pre-defined prefix
 * @return {function(): string}
 */


var localClsnms = function localClsnms(prefix) {
  return function (skpClass) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return clsnms(prefix, skpClass)(args);
    };
  };
};
/**
 * returns a string with all query parameters connected with &
 * @param queries
 * @return {string}
 */


var parseQueryParams = function parseQueryParams(queries) {
  return Object.entries(queries).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return "".concat(key, "=").concat(value);
  }).join('&');
};

var getRandomColor = function getRandomColor() {
  var letters = '0123456789ABCDEF';
  return new Array(6).fill(null).reduce(function (color) {
    return color + letters[Math.floor(Math.random() * 10)];
  }, '#');
};

export { getRandomString as a, getRandomColor as b, clsnms as c, emailRegex as e, getColor as g, localClsnms as l, parseQueryParams as p };